export default {
    groupPanel_00001: "",
};
